import { useAxiosCreate } from '@/backend/utils.js';

const api = useAxiosCreate('admin');
const baseApi = useAxiosCreate('base');

function serializeParams(params) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.append(key, String(value));
  });
  return search.toString();
}

const PARAMS_SERIALIZER = { serialize: serializeParams };

export function resyncTrip({ trip_id, tms_id, dry = false, actor } = {}) {
  const body = {};
  if (trip_id !== undefined) body.trip_id = trip_id;
  if (tms_id !== undefined) body.tms_id = tms_id;
  return baseApi
    .post('/tms/trips/resync', body, { params: { dry }, paramsSerializer: PARAMS_SERIALIZER })
    .then((res) => res.data);
}

export function fetchResyncBlockedTrips({ page, per_page, cargo_trip_id, trip_id } = {}) {
  return api
    .get('trips/resync-blocked', {
      params: { page, per_page, cargo_trip_id, trip_id },
      paramsSerializer: PARAMS_SERIALIZER,
    })
    .then((res) => res.data);
}